import { ComponentProps, MouseEvent, useCallback, useMemo } from 'react';

import SocialLinks from './SocialLinks';

interface Props extends Omit<ComponentProps<typeof SocialLinks>, 'links'> {
  url: string;
  title?: string;
}

export default function SocialShareLinks({ url, title, ...props }: Props) {
  const onClickShare = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      navigator.share({ url, title }).catch();
    },
    [url, title],
  );

  const socialLinks = useMemo(() => {
    const canShare = typeof navigator !== 'undefined' && 'canShare' in navigator && navigator.canShare({ url, title });

    return {
      ...(canShare ? { link: onClickShare } : {}),
      linkedIn: `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
      x: `https://twitter.com/intent/tweet?url=${url}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    };
  }, [url, onClickShare, title]);

  return (
    <SocialLinks
      links={socialLinks}
      {...props}
    />
  );
}
